var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report-Editor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RptEd5.3-LineChartSingle",
    transform: "translate(-254.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(254.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PivotRowValuesIcon-Copy-4",
    fill: "#FFFFFF",
    stroke: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 29,
    rx: 2
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#37809F",
    points: "2 14.7790264 9.40673828 9.51123047 16.17399 14.4694886 22.965332 22.5175781 31.112527 14.4690484 38 7.58157547"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy",
    stroke: "#37809F",
    points: "2 21.7790264 9.2417639 14.5372624 16.1616211 20.2504883 23.6494141 16.7275391 31.0195312 19.5415039 38 14.5815755"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleLine);
export default __webpack_public_path__ + "static/media/multiple_line.61a2306a79787d23a48d7441b9c613b0.svg";
export { ForwardRef as ReactComponent };